import React from "react";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import BackToTop from "../Back-to-top/BackToTop";

const About: React.FC = () => {
	return (
		<div>
			<Header />

			<section className="bg-img1 txt-center p-lr-15 p-tb-92" style={{ backgroundImage: `url('asset/images/bg-01.png')` }}>
				<h2 className="ltext-105 cl0 txt-center">
					About
				</h2>
			</section>

			<section className="bg0 p-t-75 p-b-120">
				<div className="container">
					<div className="row p-b-148">
						<div className="col-md-7 col-lg-8">
							<div className="p-t-7 p-r-85 p-r-15-lg p-r-0-md">
								<h3 className="mtext-111 cl2 p-b-16">Our Story</h3>
								<p className="stext-113 cl6 p-b-26">It all started with a "what if?"</p>
								<p className="stext-113 cl6 p-b-26">Kryptonian Labs began with a simple chit chat between a small group of friends — the kind where ideas are shared freely and dreams are spoken out loud, without pressure or expectation. What started as "it would be nice if…" slowly turned into "why don't we actually do it?" And in that moment, we realized that sometimes, the best way to bring a dream to life is simply to start.</p>
								<p className="stext-113 cl6 p-b-26">So we did.</p>
								<p className="stext-113 cl6 p-b-26">With a lot of hope and very small steps, we began working on Kryptonian Labs on 23rd August 2025. There was no rush, no pressure — only belief, creativity, and the joy of building something together. Every decision, every sketch, every fabric choice came from a place of care, curiosity, and playfulness. Step by step, piece by piece, we allowed the brand to grow naturally, learning along the way and celebrating each small milestone.</p>
							</div>
						</div>
						<div className="col-11 col-md-5 col-lg-4 m-lr-auto">
							<div className="how-bor1">
								<div className="hov-img0">
									<img src="asset/images/about-04.png" alt="IMG" />
								</div>
							</div>
						</div>
					</div>

					<div className="row p-b-148">
						<div className="order-md-2 col-md-7 col-lg-8 p-b-30">
							<div className="p-t-7 p-l-85 p-l-15-lg p-l-0-md">
								<h3 className="mtext-111 cl2 p-b-16">Our Philosophy</h3>
								<p className="stext-113 cl6 p-b-26">Our designs are inspired by beach days, party nights, and everything in between. From relaxed, easy-going casuals to pieces made for dancing, laughing, and staying out a little longer, we create clothing that moves with life itself. Each piece reflects a sense of freedom, a love for playful details, and the desire to make you feel confident, comfortable, and joyful wherever you go.</p>
								<p className="stext-113 cl6 p-b-26">At Kryptonian Labs, we believe fashion is not just about what you wear — it's about the energy you carry. Our goal is to design pieces that allow you to express yourself, to feel at ease in your skin, and to celebrate the little and big moments that make life memorable. Every seam, every cut, and every color choice is made with thought and care, so our clothes can accompany you on your adventures, big or small.</p>
								<p className="stext-113 cl6 p-b-26">As we grow, our promise remains simple: to create the best products we can, to experiment, to explore new styles, and to offer a wide variety of pieces that let you express yourself effortlessly. This is more than a brand — it is a celebration of friendship, creativity, and the joy of building something with heart.</p>
								<p className="stext-113 cl6 p-b-26">This is Kryptonian Labs, made by friends, with hope, built slowly, and designed to enjoy.</p>
							</div>
						</div>
						<div className="order-md-1 col-11 col-md-5 col-lg-4 m-lr-auto p-b-30">
							<div className="how-bor2">
								<div className="hov-img0">
									<img src="asset/images/about-03.png" alt="IMG" />
								</div>
							</div>
						</div>
					</div>

					<div className="row p-b-148">
						<div className="col-md-7 col-lg-8">
							<div className="p-t-7 p-r-85 p-r-15-lg p-r-0-md">
								<div className="bor16 p-l-29 p-b-9 m-t-22">
									<h3 className="mtext-111 cl2 p-b-16">Our Inspiration</h3>
									<p className="stext-114 cl6 p-r-40 p-b-11">Creativity is just connecting things. When you ask creative people how they did something, they feel a little guilty because they didn't really do it, they just saw something. It seemed obvious to them after a while.</p>
									<span className="stext-111 cl8">- Steve Job's</span>
								</div>
							</div>
						</div>
						<div className="col-11 col-md-5 col-lg-4 m-lr-auto">
							<div className="how-bor1">
								<div className="hov-img0">
									<img src="asset/images/about-05.png" alt="IMG" />
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>

			<Footer />
			<BackToTop />
		</div>
	);
};

export default About;